import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { WorkspacesBreadcrumbs } from '../WorspacesBreadcrumbs'
import { Suspense } from 'react'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { WorkspaceDatabricksPageContentV2 } from './WorkspaceDatabricksPageContentV2'

export function WorkspaceDatabricksPage() {
  return (
    <>
      <WorkspacesBreadcrumbs title="Databricks" />
      <QueryErrorBoundary errorMessage="Failed to fetch application">
        <Suspense fallback={<LoadingComponent className="flex-1" />}>
          <WorkspaceDatabricksPageContentV2 />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}
